// extracted by mini-css-extract-plugin
export default {"yearNav":"index_yearNav_Oi0mf","yearNavItem":"index_yearNavItem_IJXZ1","active":"index_active_vSMiD"};